const filtersInfos = {
  contact_customerRisk: 'smartmessaging.filterInfos.customerRisk',
  customerRisk: 'smartmessaging.filterInfos.customerRisk',
};
export default filtersInfos;
